import { useState, useEffect, Fragment } from "react"
import cc from "classcat"
import { useController } from "react-hook-form"
import { Listbox } from "@headlessui/react"

import { Label } from "components/atoms/form"
import { toDateTimeShortFormat } from "utils/date"

import { ChevronUpDownIcon } from "@heroicons/react/20/solid"

export const Select = (props) => {
  const {
    field: { value, onChange, ref },
    fieldState: { error },
  } = useController({
    ...props,
    rules: {
      required: props.required,
    },
  })

  const {
    items,
    label,
    required,
    onChange: externalOnChange = (e) => {},
  } = props

  return (
    <div className="block w-full sm:inline-flex">
      <div className="w-full">
        <Label label={label} required={required} error={error} />
        <Listbox
          onChange={(e) => {
            onChange(e)
            externalOnChange(e)
          }}
          value={value}
        >
          <div className="relative flex">
            <Listbox.Button
              ref={ref}
              className="relative z-0 inline-flex h-10 w-full appearance-none rounded-lg border border-zinc-300 bg-white px-3 py-2 pl-3 pr-8 text-left text-sm leading-normal text-zinc-800 focus:border-0 focus:ring-2 focus:ring-blue-600"
            >
              {value?.time && (
                <span className="mr-1 shrink-0 font-bold">
                  {toDateTimeShortFormat(value.time)}
                </span>
              )}
              <span className="truncate">{value?.title || ""}</span>
              <span className="pointer-events-none absolute inset-y-0 right-1 flex items-center ">
                <ChevronUpDownIcon
                  className="h-4 w-4 text-zinc-400"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>
            <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              {items.map((item) => (
                <Listbox.Option
                  key={item.id}
                  value={item}
                  className={({ active }) =>
                    cc([
                      active ? "bg-teal-100 text-teal-900" : "text-zinc-900",
                      "relative cursor-default select-none py-2 px-3 text-sm",
                    ])
                  }
                >
                  <span className="block truncate text-left">
                    <span className="font-bold">
                      {item.time && toDateTimeShortFormat(item.time)}
                    </span>{" "}
                    {item.title}
                  </span>
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </div>
        </Listbox>
      </div>
    </div>
  )
}
